import { toUnityFixed } from '../../../../helpers/unityHelper';
import { modifyCutawayLayer } from '../ProductBuilderComponents/commonHelper';

export class UndoRedoCutaway {
  constructor({ undoRedoInstance }) {
    this.undoRedo = undoRedoInstance;
    this.pending = new Map();
    this.createAction = this.undoRedo.createAction;
    this._init();
  }

  _init() {
    this._pushShapeChange = this.createAction(
      ({ prevShape, nextShape, allLayers, updateCallback }) => {
        if (prevShape === nextShape) return false;
        
        return {
          __ACTION__: 'CUTAWAY_SHAPE_CHANGE',
          undo: () => {
            updateCallback?.(prevShape, allLayers);
          },
          redo: () => {
            updateCallback?.(nextShape, allLayers);
          },
        };
      }
    );

    this._pushSliderChange = this.createAction(
      ({ prevValue, nextValue, layerObjectName, cutawayShape, propertyType, updateCallback }) => {
        if (prevValue === nextValue) return false;
        
        return {
          __ACTION__: 'CUTAWAY_SLIDER_CHANGE',
          undo: () => {
            updateCallback?.(layerObjectName, prevValue, propertyType, cutawayShape);
          },
          redo: () => {
            updateCallback?.(layerObjectName, nextValue, propertyType, cutawayShape);
          },
        };
      }
    );
  }

  addShapeChangeAction({ prevShape, nextShape, allLayers, updateCallback }) {
    this._pushShapeChange({
      prevShape,
      nextShape,
      allLayers,
      updateCallback,
    });
  }

  startSliderChange({ layerObjectName, propertyType, initialValue, cutawayShape }) {
    const key = `${layerObjectName}__${propertyType}`;
    this.pending.set(key, {
      layerObjectName,
      propertyType,
      initialValue: toUnityFixed(initialValue, 3),
      cutawayShape,
    });
  }

  updatePendingSliderChange({ layerObjectName, propertyType, currentValue }) {
    const key = `${layerObjectName}__${propertyType}`;
    const item = this.pending.get(key);
    if (!item) return;
    item.lastValue = toUnityFixed(currentValue, 3);
  }

  endSliderChange({ layerObjectName, propertyType, finalValue, cutawayShape, updateCallback }) {
    const key = `${layerObjectName}__${propertyType}`;
    const item = this.pending.get(key);
    if (!item) return;
    
    const prevValue = item.initialValue;
    const nextValue = toUnityFixed(finalValue, 3);
    
    this._pushSliderChange({
      prevValue,
      nextValue,
      layerObjectName,
      cutawayShape,
      propertyType,
      updateCallback,
    });
    
    this.pending.delete(key);
  }

  clearAll() {
    this.pending.clear();
  }
}
